module.exports = __webpack_public_path__ + "static/media/face-woman-outline.c939cf86.svg";